import React from 'react';
import { SearchDialogAnalyticsContext } from '../analytics';
export const QuickFindAnalyticContext = ({
  children,
  isQuickFind = false
}) => /*#__PURE__*/React.createElement(SearchDialogAnalyticsContext, {
  analyticContext: {
    isQuickFind: isQuickFind
  },
  nonPrivacySafeAnalyticContext: {}
}, children);